// src/components/CleanupLog.js — per-CID live log with pause/resume/stop

import React from 'react';

const STATUS_LABEL = {
  pending: 'queued',
  'in-progress': 'working…',
  deleted: '✓ deleted (verified)',
  'still-present': '✗ still present — mechanism failed',
  undeletable: '✗ could not delete',
  'already-absent': '— already gone',
};

const CleanupLog = ({ state, onPause, onResume, onStop, onDone }) => {
  const orphans = state.orphans || [];

  const doneCount = orphans.filter(
    (o) => o.status === 'deleted' || o.status === 'undeletable' || o.status === 'already-absent'
  ).length;

  const stillPresent = orphans.filter((o) => o.status === 'still-present').length;
  const isComplete = !!state.completedAt;

  return (
    <div className="cleanup-log">
      <div className="report-head">
        <h2>Cleanup</h2>
        <div className="cleanup-controls">
          {!isComplete && (
            <>
              <button onClick={onPause} className="pause-button">Pause</button>
              <button onClick={onResume} className="resume-button">Resume</button>
              <button onClick={onStop} className="stop-button">Stop</button>
            </>
          )}
          <button onClick={onDone} className="done-button">Back to report</button>
        </div>
      </div>

      {state.note && <div className="banner">{state.note}</div>}

      {isComplete ? (
        <div className="cleanup-summary">
          <p><strong>Run complete.</strong></p>
          <ul>
            <li>Deleted (verified): {orphans.filter((o) => o.status === 'deleted').length}</li>
            <li>Already absent: {orphans.filter((o) => o.status === 'already-absent').length}</li>
            <li>Undeletable: {orphans.filter((o) => o.status === 'undeletable').length}</li>
            {stillPresent > 0 && (
              <li className="error">Still present (mechanism failed): {stillPresent}</li>
            )}
          </ul>
          <p className="muted">
            Verify independently:{' '}
            <a href={`https://atproto.at/uri/at://${state.did}#blobs`} target="_blank" rel="noreferrer">
              atproto.at
            </a>
          </p>
        </div>
      ) : (
        <p className="muted">
          {doneCount} / {orphans.length} processed. One blob at a time, paced to
          respect the PDS rate budget.
        </p>
      )}

      <ul className="cleanup-log-list">
        {orphans.map((o) => (
          <li key={o.cid} className={`cleanup-entry cleanup-${o.status}`}>
            <span className="cleanup-status">{STATUS_LABEL[o.status] || o.status}</span>
            <code className="cleanup-cid">{o.cid.slice(0, 24)}…</code>
            {o.detail && <span className="muted cleanup-detail">{o.detail}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CleanupLog;
